import apiService from '../../../repositories/apiService';

export default {
    paginatedFetch({ rootGetters, commit, state }, url) {
        return new Promise((resolve, reject) => {
            // callback(state.itemsPerPage, state.currentPage)
            apiService.get(
                `${url}`,
                {
                    params: {
                        page: state.currentPage,
                        page_size: state.itemsPerPage,
                        search: state.searchQuery
                    },
                },
            )
                .then((response) => {
                    commit('setCurrentPage', response.data.meta.current_page);
                    commit('setLastPage', response.data.meta.last_page);
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    paginatedFetchWithPayload({ rootGetters, commit, state }, payload) {
        return new Promise((resolve, reject) => {
            apiService.get(
                `${payload.url}`,
                {
                    headers: {
                        Authorization: rootGetters.token
                    },
                    params: {
                        page: state.currentPage,
                        page_size: state.itemsPerPage,
                        search: state.searchQuery,
                        statusFilter: payload.filter,
                        location: payload.location
                    },
                },
            )
                .then((response) => {
                    resolve(response);
                    commit('setCurrentPage', response.data.meta.current_page);
                    commit('setLastPage', response.data.meta.last_page);
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    searchUpdated({ commit }, payload) {
        commit('setSearch', payload.search);
    },
};
